const AI_SERVICE_FAILURE_STATUSES = new Set([401, 403, 429, 503]);
const AI_SERVICE_FAILURE_CODES = new Set([
  "invalid_api_key",
  "organization_deactivated",
  "service_unavailable",
  "rate_limit_exceeded",
  "insufficient_quota",
]);

export const isAiServiceFailure = (source = {}) => {
  const status = Number(source?.aiErrorStatus || source?.errorStatus || source?.status);
  const code = String(source?.aiErrorCode || source?.errorCode || source?.code || "");

  if (AI_SERVICE_FAILURE_STATUSES.has(status)) {
    return true;
  }

  return AI_SERVICE_FAILURE_CODES.has(code);
};
